var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "@/interface/IVueDialog";
import AccoutCheckService from '../../../api/AccoutCheckService';
import { Loading } from 'element-ui';
import { saveAs } from 'file-saver';
import EAccountStatus from "../../../enum/EAccountStatus";
var AttachmentDialog = (function (_super) {
    __extends(AttachmentDialog, _super);
    function AttachmentDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pdfDialogVisible = false;
        _this.pdfDialogUrl = '';
        _this.type = '';
        _this.renameDialogVisible = false;
        _this.currentAttachment = null;
        _this.renameText = '';
        _this.attachmentList = [];
        _this.limit = 10;
        _this.maxSize = 5;
        _this.statusList = EAccountStatus;
        _this.timer = null;
        _this.isFirstLoad = true;
        _this.previewImg = '';
        _this.parentPageAuth = {};
        return _this;
    }
    AttachmentDialog.prototype.previewImage = function (item) {
        var type = item.document_pic.slice(-3).toLowerCase();
        if (type !== 'pdf') {
            this.previewImg = item.document_pic;
            this.$refs.previewImg.showViewer = true;
        }
        else {
            this.pdfDialogUrl = item.document_pic;
            this.pdfDialogVisible = true;
        }
    };
    AttachmentDialog.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
        this.order_status_name = this.detail.order_status_name || '';
        this.getAttachmentList();
    };
    AttachmentDialog.prototype.getLimit = function () {
        var num = this.limit - this.attachmentList.length;
        return num;
    };
    AttachmentDialog.prototype.getAttachmentList = function () {
        var _this = this;
        var loadingInstance;
        if (this.isFirstLoad) {
            loadingInstance = Loading.service({ fullscreen: true });
        }
        var param = {};
        if (this.type === 'edit') {
            param = {
                order_id: this.detail.order_id,
                document_type: 12
            };
        }
        else {
            param = {
                supplier_to_business_id: this.detail.supplier_to_business_id,
                document_type: 12
            };
        }
        this.service.getOrderDocumentList(param).then(function (res) {
            _this.isFirstLoad = false;
            loadingInstance && loadingInstance.close();
            var data = res.data;
            if (data.success) {
                _this.attachmentList = (data.data || []);
            }
        }).catch(function (err) {
            _this.isFirstLoad = false;
            loadingInstance && loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    AttachmentDialog.prototype.beforUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "jpeg" || fileType == 'jpg' || fileType == "png" || fileType == "pdf"))) {
            this.$message.error("上传文件不符合格式，只能jpeg、jpg、png、pdf格式");
            return false;
        }
        ;
        var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单个文件不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
    };
    AttachmentDialog.prototype.exceedLimit = function (files, fileList) {
        this.$message({
            showClose: true,
            message: "最多上传" + (this.limit) + "张附件",
            type: 'error'
        });
    };
    AttachmentDialog.prototype.uploadError = function (err, file, fileList) {
        this.$message.error(err.msg || err.message || "网络异常，请重新上传");
        this.loadingInstanceAll.close();
    };
    AttachmentDialog.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        this.loadingInstanceAll = Loading.service({ fullscreen: true });
        if (response.success) {
            var params = {
                order_document: JSON.stringify([{ url: response.data.full_path, text: response.data.file_name }]),
                order_id: this.type == 'edit' ? this.detail.order_id : null,
                supplier_to_business_id: this.detail.supplier_to_business_id,
                document_type: 12
            };
            this.service.updateInvoice(params).then(function (res) {
                _this.loadingInstanceAll.close();
                _this.getAttachmentList();
            }).catch(function (err) {
                _this.loadingInstanceAll.close();
                _this.$message.error(err.message || err.msg);
            });
        }
        else {
            this.$message.error(response.msg);
        }
    };
    AttachmentDialog.prototype.removeAttachment = function (item) {
        var _this = this;
        this.$confirm('请确认是否删除').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.deleteOrderDocument({
                order_id: _this.detail.order_id,
                order_document_id: item.document_id
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code === 0) {
                    _this.$message.success('删除成功');
                    _this.getAttachmentList();
                }
                else {
                    _this.$message.error(res.data.msg || '删除失败');
                }
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    AttachmentDialog.prototype.renameAttachment = function (item) {
        this.currentAttachment = item;
        this.renameText = item.document_name;
        this.renameDialogVisible = true;
    };
    AttachmentDialog.prototype.renameSubmit = function () {
        var _this = this;
        if (this.renameText.trim() == '') {
            this.$message.info('请输入附件名称');
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.renameOrderDocument({
            order_id: this.currentAttachment.order_id,
            order_document_id: this.currentAttachment.document_id,
            document_name: this.renameText
        })
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code === 0) {
                _this.$message.success('重命名成功');
                _this.renameDialogVisible = false;
                _this.getAttachmentList();
            }
            else {
                _this.$message.error(res.data.msg || '重命名失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    AttachmentDialog.prototype.downAllAttachment = function () {
        if (this.attachmentList.length == 0) {
            return;
        }
        var order_id = this.detail.order_id ? this.detail.order_id : '';
        var url = "supplierclientapi/statementorder/download_order_document?order_id=" + order_id + '&supplier_to_business_id=' + this.detail.supplier_to_business_id + '&document_type=12&token=' + this.token;
        location.href = url;
    };
    AttachmentDialog.prototype.downAttachment = function (item) {
        var name = item.document_name, url = item.document_pic;
        if (!name.includes('.')) {
            name = name + "." + url.slice(-3);
        }
        saveAs(url.replace(/(http:|https:)([\w\W]+)/, location.protocol + '$2'), name);
    };
    AttachmentDialog.prototype.close = function () {
        this.$emit('submitSuccess');
        this.$closeDialog();
    };
    AttachmentDialog.prototype.submit = function () {
        var _this = this;
        if (this.attachmentList.length == 0) {
            this.$closeDialog();
            this.$emit('submitSuccess');
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        var param = {
            order_id: this.detail.order_id,
            document_type: 12
        };
        this.service.confirmOrderDocument(param).then(function (res) {
            loadingInstance.close();
            if (res.data.code === 0) {
                _this.$message.success(res.data.msg || '附件提交成功');
                _this.$closeDialog();
                _this.$emit('submitSuccess');
            }
            else {
                _this.$message.error(res.data.msg || '提交失败');
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    AttachmentDialog.prototype.mounted = function () {
    };
    AttachmentDialog.prototype.destroyed = function () {
        clearInterval(this.timer);
    };
    AttachmentDialog = __decorate([
        Component({
            computed: {
                previewImgList: function () {
                    var list = this.attachmentList.filter(function (item) {
                        var type = item.document_pic.slice(-3).toLowerCase();
                        return type !== 'pdf';
                    });
                    return list.map(function (item) { return item.document_pic; });
                },
                canEdit: function () {
                    return this.detail.is_confirm != 2;
                },
                canOperateDocument: function () {
                    return this.parentPageAuth.Invoice && !(this.detail.order_status === this.statusList['已废弃'] || this.detail.order_status === this.statusList['反审核']);
                },
                canAuditOperateDocument: function () {
                    return this.parentPageAuth.Invoice && !(this.detail.order_status === this.statusList['已废弃'] || this.detail.order_status === this.statusList['反审核']);
                },
                showUploadButton: function () {
                    return (this.detail.order_status == 0
                        || this.detail.order_status == 1
                        || this.detail.order_status == 7
                        || (this.detail.order_status == 2 && this.detail.is_confirm == 0)
                        || this.detail.is_confirm == 1
                        || this.detail.can_create_docuemnt == 0);
                }
            }
        })
    ], AttachmentDialog);
    return AttachmentDialog;
}(IVueDialog));
export default AttachmentDialog;
